import { Search } from "@mui/icons-material"
import ClearRoundedIcon from "@mui/icons-material/ClearRounded"
import { IconButton, InputAdornment } from "@mui/material"
import { StyledSearchField } from "."

export function CustomSearch({
  name,
  value,
  label,
  handleClearSearch,
  component: TextFieldComponent = StyledSearchField,
  ...rest
}) {
  return (
    <TextFieldComponent
      name={name}
      value={value}
      label={label}
      type="search"
      variant="outlined"
      fullWidth
      size="small"
      InputProps={{
        startAdornment: (
          <InputAdornment position="start">
            <IconButton disableRipple>
              <Search />
            </IconButton>
          </InputAdornment>
        ),
        endAdornment: value && (
          <IconButton
            disableRipple
            aria-label="toggle password visibility"
            onClick={handleClearSearch}
          >
            <ClearRoundedIcon />
          </IconButton>
        ),
      }}
      {...rest}
    />
  )
}
